import React, { useEffect, useRef, useState } from "react";
import { ReactComponent as SendButton } from "../../Global Icons/Send Button.svg";
import { useDispatch, useSelector } from "react-redux";
import { getChatPaymentExecById } from "../../Redux/Actions/chatAction";
import Socket from "../../Global Functions/socket";
import TextInput from "../../Global Functions/textInput";
import { ReactComponent as Logo } from "../../Global Icons/ProptekLogo.svg";

const ChatComponent = ({ selectedBookingId }) => {
  const dispatch = useDispatch();

  const [messages, setMessages] = useState([]);
  const [inputMessages, setInputMessages] = useState("");

  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 10,
    total: 0,
  });

  const messageListRef = useRef(null);

  const { individualChat } = useSelector((state) => state.chats || {});
  const { admin } = useSelector((state) => state.admin || {});

  const sendMessages = () => {
    if (!inputMessages?.trim()) return;

    const messagePayload = {
      message: inputMessages,
      booking_id: selectedBookingId,
      project_id: "67f8edfe9a1b8d002d117673",
      chat_with: "support",
      admin_id: admin?.data?._id,
    };

    Socket.emit("payment-executive-chat", messagePayload, (response) => {
      if (response.status === "success") {
       
        setMessages((prev) => [...prev, messagePayload]);
        setInputMessages("");
      } else {
        console.log(response.message || "Failed to send");
      }
    });
    setInputMessages("");
  };

  const fetchDetails = (page, limit, selectedBookingId) => {
    const chatData = {
      page,
      limit,
      booking_id: selectedBookingId,
    };
    dispatch(getChatPaymentExecById(chatData));
  };

  useEffect(() => {
    fetchDetails(pagination.current, pagination.pageSize, selectedBookingId);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedBookingId]);

  useEffect(() => {
    if (individualChat?.total) {
      setPagination((prevData) => ({
        ...prevData,
        total: individualChat.total,
      }));
    }
  }, [individualChat]);

  useEffect(() => {
    if (Array.isArray(individualChat?.data)) {
      setMessages((prevMessages) =>
        pagination.current === 1
          ? individualChat.data
          : [...prevMessages, ...individualChat.data]
      );
    }
  }, [individualChat, pagination]);

  // const handleScrollChange = (pagination) => {
  //   setPagination(pagination);
  //   fetchDetails(pagination.current, pagination.pageSize, selectedBookingId);
  // };

  useEffect(() => {
    const messageList = messageListRef.current;

    const handleScroll = () => {
      if (messageList.scrollTop < 50 && messages.length < pagination.total) {
        // User scrolled near top, load older messages
        const nextPage = pagination.current + 1;
        setPagination((prev) => ({ ...prev, current: nextPage }));
        fetchDetails(nextPage, pagination.pageSize, selectedBookingId);
      }
    };

    if (messageList) {
      messageList.addEventListener("scroll", handleScroll);
    }

    return () => {
      if (messageList) {
        messageList.removeEventListener("scroll", handleScroll);
      }
    };
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [messages, pagination.total, selectedBookingId]);

  useEffect(() => {
    if (selectedBookingId) {
      fetchDetails(pagination.current, pagination.pageSize, selectedBookingId);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pagination.current]);

  useEffect(() => {
    const listener = (message) => {
      setMessages((prev) => [message, ...prev]);
    };

    if (selectedBookingId) {
     

      Socket.on(`${selectedBookingId}`, listener);

      return () => {
        Socket.off(`${selectedBookingId}`, listener);
      };
    }
  }, [selectedBookingId]);

  return (
    <div className="chat-window">
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          padding: "10px 20px",
          alignItems: "center",
        }}
      >
        <h2>{selectedBookingId || "No Chat Selected"}</h2>
        <Logo></Logo>
      </div>
      <hr />
      <div className="message-list">
        {selectedBookingId &&
          messages.map((chat, index) => {
            const isAdmin = chat?.admin_id;
            return (
              <div
                className={`message_div ${
                  isAdmin ? "admin-message" : "user-message"
                }`}
                key={index}
              >
                <div className="message-content">
                  <h2>{chat?.message}</h2>
                  <p>
                    {new Date(chat?.created_at).toLocaleString().slice(10, 20)}
                  </p>
                </div>
              </div>
            );
          })}
      </div>
      <div className="input-area">
        <TextInput onChange={(event) => setInputMessages(event.target.value)} />
        <SendButton style={{ cursor: "pointer" }} onClick={sendMessages} />
      </div>
    </div>
  );
};

export default ChatComponent;
